/**
 * Helpers para sparklines (paquete AE).
 *
 * Provee `bucketsPorDia` para agrupar cualquier array de items con un campo
 * fecha en 7 buckets (hace 6 días → hoy). El bucket index 0 es el más viejo,
 * 6 es el más nuevo. Pure function — testeable sin DOM.
 *
 * Convención: el "hoy" se inyecta para tests (default: new Date()). Se cuenta
 * por día calendario, no por ventana móvil — un item de las 23:50 cae en el
 * día calendario actual, no en el siguiente.
 */

const MS_POR_DIA = 24 * 60 * 60 * 1000;

/** Recorta `date` al inicio del día (00:00:00.000) en zona local. */
function inicioDelDia(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function bucketsPorDia<T>(
  items: readonly T[],
  getFecha: (item: T) => string | Date,
  hoy: Date = new Date(),
): number[] {
  const buckets: number[] = [0, 0, 0, 0, 0, 0, 0];
  const hoyInicio = inicioDelDia(hoy).getTime();
  for (const item of items) {
    const f = getFecha(item);
    const t = inicioDelDia(typeof f === 'string' ? new Date(f) : f).getTime();
    const diasAtras = Math.floor((hoyInicio - t) / MS_POR_DIA);
    if (diasAtras >= 0 && diasAtras < 7) {
      // Index 0 = hace 6 días, index 6 = hoy
      const idx = 6 - diasAtras;
      const prev = buckets[idx] ?? 0;
      buckets[idx] = prev + 1;
    }
  }
  return buckets;
}
